export const FETCH_PAGINATED_CUSTOMERS = 'customers/fetchPaginatedCustomers';
